import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  surveyContent: {
    display: 'flex',
    marginTop: '15px',
  },
  editionArea: {
    textAlign: 'center',
    flexGrow: '1',
    width: '100%',
    '& div:first-child': {
      flexGrow: '1',
    },
  },
  questionTitle: {
    width: '100%',
    marginLeft: '0px',
    marginBottom: '0px',
    marginTop: '1rem',
    paddingLeft: '0px',
    textAlign: 'left',
  },
  pageInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& div': {
      display: 'flex',
      alignItems: 'center',
      '& p': {
        marginRight: '10px',
      },
    },
    '& svg': {
      color: theme.palette.primary.lightGray,
    },
  },
  selectedPageGeneralView: {
    borderRadius: '10px',
    border: `2px dotted ${theme.palette.secondary.blue}`,
    marginLeft: '-18px',
    marginBottom: '0px',
  },
  generalViewPageTitle: {
    backgroundColor: theme.palette.custom.cardBackground,
    borderRadius: '10px',
    marginBottom: '10px',
  },
  pageTitle: {
    color: theme.palette.primary.gray,
    fontSize: '14px',
  },
  viewQuestion: {
    color: `${theme.palette.secondary.blue} !important`,
    marginRight: '10px',
  },
  switch: {
    width: 28,
    height: 16,
    padding: 0,
    margin: '0 5px 0 10px',
    display: 'flex',
    '& .MuiSwitch-thumb': {
      width: 16,
      height: 16,
      borderRadius: 8,
      boxShadow: 'none',
    },
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: theme.palette.secondary.blue,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.primary.gray,
    },
    '& .MuiSwitch-switchBase': {
      padding: 0,
      color: theme.palette.primary.white,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
      },
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.primary.gray,
    },
  },
  selectedPageStyle: {
    borderRadius: '10px',
    border: `2px dotted ${theme.palette.secondary.blue}`,
  },
  hideContent: {
    display: 'none',
  },
  // '#22617B' is exactly `primary.mainBlue`, which already has a dark value.
  loadingText: {
    color: theme.palette.primary.mainBlue,
  },
}));

export default useStyles;
